<template>
  <span class="gj-local-time">
    <slot name="label"><span>{{label | defaultShow('', '：', '')}}</span></slot>{{localTimeText}}
  </span>
</template>

<script>
  import {convertToFullDate, getLocalTime} from "../../utils/date.util";
  import {addSeconds} from "date-fns";
  import {isMeaningful, isMeaningless} from "../../utils/common";

  export default {
    name: "gj-local-time",
    props: {
      time: {
        default: null
      },
      timezone: {
        type: Number,
        default: 8
      },
      label: {
        type: String
      }
    },
    data() {
      return {
        localTime: null,
        handle: null
      }
    },
    watch: {
      time: {
        handler: function(time) {
          if (isMeaningless(time) || isMeaningless(this.timezone)) {
            return;
          }
          if (isMeaningful(time)) {
            this.localTime = new Date(time);
          } else {
            this.localTime = getLocalTime(this.timezone);
          }
          if (this.handle) {
            clearInterval(this.handle);
          }
          this.handle = setInterval(() => {
            this.localTime = addSeconds(this.localTime, 1);
          }, 1000);
          this.$once('hook:beforeDestroy', function () {
            clearInterval(this.handle);
          });
        },
      }
    },
    computed: {
      localTimeText() {
        return convertToFullDate(this.localTime, 'yyyy-MM-dd HH:mm:ss');
      }
    }
  }
</script>

<style scoped>
  .gj-local-time {
    color: #333;
    font-size: 12px;
  }
</style>
